<template>
	<div class="d-flex align-center justify-center container">
		<Content :is-mobile="isXS">
			<div class="d-flex flex-column gap-5">
				<h1 :class="isXS ? 'text-heading-xl' : 'text-heading-xxl'">
					{{ title }}
				</h1>
				<p v-if="message" class="text-body-xl">
					{{ message }}
				</p>
				<div>
					<PButton type-filled @click="$emit('actionClicked')">
						{{ actionText }}
					</PButton>
				</div>
			</div>
		</Content>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		title: string
		message: string
		actionText: string
		isXS: boolean
	}

	defineProps<Props>()
	defineEmits(['actionClicked'])
</script>

<style lang="scss" scoped>
	.container {
		height: 80vh;
	}
</style>
